// Centralized BrightLabs brand / contact constants
// Update these in one place — they propagate everywhere.

export const BRAND = {
  name: 'BrightLabs',
  tagline: 'AI-Powered Growth Systems',
  // Phone
  phoneDisplay: '01603 976281',
  phoneTel: '+441603976281',
  // Email
  email: 'hello@brightlabs.live',
  // Location
  city: 'Norwich',
  region: 'Norfolk',
  country: 'United Kingdom',
  countryShort: 'UK',
  postcode: 'NR1',
  serviceArea: 'UK-wide',
  locationLine: 'Based in Norwich · Serving UK-wide',
  // Hours
  hoursDisplay: 'Mon–Fri · 9am–6pm',
  hoursSchema: 'Mo-Fr 09:00-18:00',
  // Web
  url: 'https://brightlabs.live',
  // Social
  facebook: 'https://www.facebook.com/profile.php?id=61585080297139',
  instagram: 'https://instagram.com/brightlabs.live',
  linkedin: 'https://linkedin.com/company/brightlabs-live',

  // ---- India market ----
  indiaWhatsApp: '+917875563175',
  indiaWhatsAppDisplay: '+91 78755 63175',
  indiaCity: 'Bengaluru',
  indiaRegion: 'India',
  indiaLocationLine: 'Now serving Indian small businesses',
  indiaTimezone: 'Asia/Kolkata',
  indiaTimezoneLabel: 'IST',
  ukTimezone: 'Europe/London',
  ukTimezoneLabel: 'UK',
};

// WhatsApp deeplink helper — pre-fills a message; works on mobile + web
export const whatsappHref = (number, message = '') => {
  const num = (number || '').replace(/[^0-9]/g, '');
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${num}${text}`;
};

// LocalBusiness JSON-LD for SEO (LocalBusiness > ProfessionalService)
export const localBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: BRAND.name,
  description: 'AI-powered websites, custom software, automation and marketing systems for ambitious UK businesses. Outsourced growth department for trades, recruitment, gyms, clinics and local service businesses.',
  url: BRAND.url,
  telephone: BRAND.phoneTel,
  email: BRAND.email,
  priceRange: '££',
  image: `${BRAND.url}/og-image.png`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: BRAND.city,
    addressRegion: BRAND.region,
    addressCountry: 'GB',
  },
  areaServed: {
    '@type': 'Country',
    name: 'United Kingdom',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  sameAs: [BRAND.facebook, BRAND.instagram, BRAND.linkedin],
});
